/**
 * Initializes .att-wrapper elements (specs table from metafields).
 * Re-runs after variant change because media-gallery replace doesn't execute inline scripts.
 */
(function () {
  function initAttWrapper(wrapper) {
    var raw = wrapper.querySelector('.att-raw');
    var output = wrapper.querySelector('.att-output');
    if (!raw || !output) return;

    var elements = raw.querySelectorAll('p, li');
    var html = '';
    var tableRows = [];
    var tableType = null;
    var pipeRegex = /\s*\|\s*/;

    function esc(str) {
      var d = document.createElement('div');
      d.appendChild(document.createTextNode(str));
      return d.innerHTML;
    }

    function flush() {
      if (!tableRows.length) return;
      var cls = tableType === 'pipe' ? ' att-pipe' : '';
      html += '<table class="att-table' + cls + '"><tbody>';
      tableRows.forEach(function (r) {
        html += '<tr><td>' + esc(r[0]) + '</td><td>' + esc(r[1]) + '</td></tr>';
      });
      html += '</tbody></table>';
      tableRows = [];
      tableType = null;
    }

    elements.forEach(function (el) {
      var text = (el.textContent || '').replace(/\u00a0/g, ' ').trim();
      if (!text) return;
      text = text.replace(/^[\*\-\u2022]\s*/, '');
      if (!text) return;

      if (pipeRegex.test(text) && text.indexOf('|') !== -1 && text.indexOf('|') > 0 && text.indexOf('|') < text.length - 1) {
        if (tableType && tableType !== 'pipe') flush();
        var parts = text.split(pipeRegex);
        tableType = 'pipe';
        tableRows.push([parts[0].trim(), parts.slice(1).join(' | ').trim()]);
        return;
      }

      var ci = text.indexOf(': ');
      if (ci !== -1 && ci < text.length - 2) {
        if (tableType && tableType !== 'colon') flush();
        tableType = 'colon';
        tableRows.push([text.substring(0, ci).trim(), text.substring(ci + 2).trim()]);
        return;
      }

      if (text.charAt(text.length - 1) === ':') {
        flush();
        html += '<h3 class="att-heading">' + esc(text.replace(/:$/, '')) + '</h3>';
        return;
      }

      flush();
      html += '<p class="att-text">' + esc(text) + '</p>';
    });

    flush();
    output.innerHTML = html;
  }

  function initAll() {
    document.querySelectorAll('.att-wrapper').forEach(initAttWrapper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('variant:updated', initAll);
})();
